module.exports = __webpack_public_path__ + "assets/img/i_pay1.9759c2d7.png";